import React from "react";
import { DialogActions, Typography, Box } from "@material-ui/core";
import { platforms } from "./Platforms";
import { IOSShareIcon, FireFoxA2HSIcon, MenuIcon, OperaA2HSIcon } from "./Icons";
import { Button } from "bc-front-sagacomponents";

function DialogActionWithInstructions(props) {
  return (
    <div>
      <div>
        <Typography variant="subtitle1">Pour installer l'application : </Typography>
        <ul>
          <li>
            <span style={{ display: "flex", alignItems: "center" }}>{props.action1}</span>
          </li>
          <li>{props.action2}</li>
        </ul>
      </div>
      <div width="100%" textAlign="right">
        <Button onClick={props.onSubmit} title="Ok"></Button>
      </div></div>
  );
}

export default function InstallDialogAction(props) {
  return (
    <>
      <DialogActions>
        {props.platform === platforms.NATIVE && (
          <>
            {/* <Button onClick={props.onClose} title="Annuler" />
            <Button onClick={props.onSubmit} color="primary" variant="contained" disableElevation title="Installer" /> */}
            <DialogActionWithInstructions
            action1={
              <>
                Cliquer sur le bouton menu
                <MenuIcon />
              </>
            }
            action2="puis cliquer sur 'Ajouter à l'écran d'accueil'"
            onSubmit={props.onSubmit}
          />
          </>
        )}
        {props.platform === platforms.IDEVICE && (
          <DialogActionWithInstructions
            action1={
              <>
               Sur Safari, cliquer sur le bouton de partage
                <IOSShareIcon />
              </>
            }
            action2="puis cliquer sur : Sur l'écran d'accueil"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.FIREFOX && (
          <DialogActionWithInstructions
            action1={
              <>Cliquer sur cette icône dans la barre d'adresse : 
                <FireFoxA2HSIcon />
              </>
            }
            action2="puis cliquer sur '+Ajout à l'écran d'accueil'"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.FIREFOX_NEW && (
          <DialogActionWithInstructions
            action1={
              <>
                Cliquer sur le bouton menu
                <MenuIcon />
              </>
            }
            action2="puis cliquer sur 'Installer'"
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.OPERA && (
          <DialogActionWithInstructions
            action1={
              <>
              Cliquer sur le bouton menu
                <MenuIcon />
              </>
            }
            action2={
              <>
                puis cliquer &nbsp;'
                <OperaA2HSIcon />
               écran d'accueil'
              </>
            }
            onSubmit={props.onSubmit}
          />
        )}
        {props.platform === platforms.OTHER && (
          <Box width="100%" display="flex" flexDirection="column">
            <Box>Malheureusement votre navigateur ne supporte pas encore la possibilité d'installer une application. </Box>
            <Box width="100%" textAlign="right">
              <Button onClick={props.onClose}>Ok</Button>
            </Box>
          </Box>
        )}
      </DialogActions>
    </>
  );
}
